/*
 * Vibee announcement message rotation
 * -----------------------------------
 * Rotates [data-vibee-announcement-rotate] message stack every 4s with a
 * 0.3s opacity fade. Respects prefers-reduced-motion (first message only).
 */
(function () {
  if (window.__vibeeAnnouncementRotateInit) return;
  window.__vibeeAnnouncementRotateInit = true;

  var ROTATE_MS = 4000;

  function init(root) {
    var messages = root.querySelectorAll('[data-vibee-announcement-message]');
    if (messages.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var index = 0;

    function setActive(nextIndex) {
      messages.forEach(function (node, i) {
        node.classList.toggle('vibee-announcement__message--active', i === nextIndex);
      });
    }

    window.setInterval(function () {
      index = (index + 1) % messages.length;
      setActive(index);
    }, ROTATE_MS);
  }

  document.querySelectorAll('[data-vibee-announcement-rotate]').forEach(init);
})();
